import filtersReducer from './filtersReducer';

export * from './filtersActions';
export default filtersReducer;
